import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferOptions from 'buffers/BufferOptions';
import BufferTabView from 'buffers/BufferTabView';
import MoleculeCanonicalSMILES from 'chemistry/molecules/tabs/MoleculeCanonicalSmiles';
import MoleculeChemicalFormula from 'chemistry/molecules/tabs/MoleculeChemicalFormula';
import MoleculeChemicalStructure, {
  MoleculeChemicalStructureSize,
} from 'chemistry/molecules/tabs/MoleculeChemicalStructure';
import MoleculeChemicalStructureTabState from 'chemistry/molecules/tabs/MoleculeChemicalStructureTabState';
import {Molecule} from 'chemistry/molecules/tabs/MoleculeFileState';
import DataConnector from 'connect/DataConnector';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface ConnectedMoleculeChemicalStructureTabProps {
  moleculeVersionId: string;
}

export interface UnconnectedMoleculeChemicalStructureTabProps {
  moleculeId: string;
  molecule: Molecule;
}

export type MoleculeChemicalStructureTabProps = ConnectedMoleculeChemicalStructureTabProps &
  UnconnectedMoleculeChemicalStructureTabProps;

class MoleculeChemicalStructureTabConnector extends DataConnector<
  UnconnectedMoleculeChemicalStructureTabProps,
  ConnectedMoleculeChemicalStructureTabProps
> {
  enhanceProps(): ConnectedMoleculeChemicalStructureTabProps {
    const moleculeVersionId =
      this.reduxState().ui.chemistry.moleculeVersionUIs[this.props.moleculeId].moleculeVersionId;
    return {moleculeVersionId};
  }
}

function MoleculeChemicalStructureTab(props: MoleculeChemicalStructureTabProps): JSX.Element {
  return (
    <div className="chemical-structure-tab">
      {!props.molecule.allowChemicalStructureEdits() && (
        <BufferOptions banner={props.molecule.getBannerText()} />
      )}
      <div className="react-tab-container">
        <MoleculeChemicalStructure
          {...props}
          size={MoleculeChemicalStructureSize.FULL_SIZE}
          editable={props.molecule.allowChemicalStructureEdits()}
        />
        <MoleculeChemicalFormula {...props} />
        <MoleculeCanonicalSMILES {...props} />
      </div>
    </div>
  );
}

const ConnectedMoleculeChemicalStructureTab = MoleculeChemicalStructureTabConnector.connect(
  MoleculeChemicalStructureTab
);

export default class MoleculeChemicalStructureTabView extends BufferTabView<MoleculeChemicalStructureTabState> {
  render(): this {
    const props = {
      moleculeId: this.model.get('moleculeId'),
      molecule: this.model.get('molecule'),
    };
    renderToDOM(<ConnectedMoleculeChemicalStructureTab {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<MoleculeChemicalStructureTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

MoleculeChemicalStructureTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
